import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-general-ledger-memo-toggle',
    templateUrl: './general-ledger-memo-toggle.component.html',
})
export class GeneralLedgerMemoToggleComponent implements OnInit
{
    showMemoColumn = false;
    constructor() {
    }

    ngOnInit(): void {
    }
}
